import React, {FC} from 'react';

import s from './main-page-section-title.module.less';

interface IMainPageSectionTitleProps {
    title: string;
}

export const MainPageSectionTitle: FC<IMainPageSectionTitleProps> = (
    {
        title,
    }: IMainPageSectionTitleProps,
) => (
    <div className={s['main-page-section-title']}>
        <div>{title}</div>
        <div className={s['main-page-section-title__separator']} />
    </div>
);

